export default __webpack_public_path__ + "static/media/insta.8d43514d.gif";